import React from "react";
import Post from "../components/Post";
import queryString from "query-string";
import Modal from "../components/Modal";
import Parser from "html-react-parser";
import { useDeals } from "../hooks";
import axios from "axios";
import { dealUrl } from "../constant";
import { useHistory } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import Translate from "../components/Translate";
import CircularProgress from '@material-ui/core/CircularProgress';
import AdSense from 'react-adsense';

const Product = (props) => {
  const [deals] = useDeals();
  const history = useHistory();

  const routeChange = React.useCallback((path) => {
    history.push(path);
  }, [history]);

  const [post, setPost] = React.useState(undefined);
  const [guideLoading, setGuideLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [store, setStore] = React.useState(undefined);
  const [guide, setGuide] = React.useState(undefined);

  const query = queryString.parse(props.location.search);
  const id = !query.id ? props.match.params.id : query.id;
  const pid = !query.pid ? props.match.params.pid : query.pid;
  const allDigits = /^\d+$/;
  if ((pid !== undefined && !allDigits.test(pid)) || (id !== undefined && !allDigits.test(id))) {
    routeChange("/");
  };

  const dealArr = React.useMemo(() => deals.filter(deal => !id ? deal.pid === pid : deal.dno === id), [pid, id, deals]);

  React.useEffect(() => {
    // if (deals.length === 0) {
    //   routeChange("/");
    // }
    if (dealArr.length === 1) {
      setPost(<Post
        deal={dealArr[0]}
        key={dealArr[0].dno}
        setModalOpen={setModalOpen}
        setStore={setStore}
        setGuide={setGuide}
        setGuideLoading={setGuideLoading}
      />);

      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    };
    if (dealArr.length === 0) {
      console.log("loading...");
      var data = new FormData();
      if (pid !== undefined) {
        data.append("pid", pid);
      } else if (id != undefined) {
        data.append("id", id);
      }
      axios
        .post(dealUrl, data, {
          timeout: 5000,
        })
        .then((response) => {
          const { data } = response;
          if (data === "0 results") {
            routeChange("/");
          }
          setPost(<Post
            deal={data[0]}
            key={data[0].dno}
            setModalOpen={setModalOpen}
            setStore={setStore}
            setGuide={setGuide}
            setGuideLoading={setGuideLoading}
          />);

          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
        }).catch((error) => {
          console.log(error);
        });

    }
  }, [deals, dealArr, id, routeChange]);

  const toggle = React.useCallback(() => setModalOpen(!modalOpen), [setModalOpen, modalOpen]);

  const skeleton = <React.Fragment><Typography component="div" key={'h1'} variant={'h1'}>
    <Skeleton />
  </Typography><div style={{ height: "380px" }}><Skeleton variant="rect" animation="wave" height={350} /></div></React.Fragment>;

  return (
    <React.Fragment>      
      <div
        style={{ marginLeft: "50px", marginRight: "50px", marginTop: "20px" }}
      >
        {post ? post : skeleton}
      </div>
      {/* <AdSense.Google
        client='ca-pub-3072979906851512'
        slot='3922802401'
        style={{ width: '100%', height: 80, }}
        format=''
      /> */}
      <Modal isOpen={modalOpen} toggle={toggle} header={`${store}'s Shopping Guide`} body={guideLoading ?
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </div> :
        guide ? Parser(Translate(guide)) :
          "No guide available."} />
    </React.Fragment>
  );

};

export default Product;
